import { render } from "./HostAllDetails.vue?vue&type=template&id=5058fc62&scoped=true"
import script from "./HostAllDetails.vue?vue&type=script&lang=js"
export * from "./HostAllDetails.vue?vue&type=script&lang=js"

import "./HostAllDetails.vue?vue&type=style&index=0&id=5058fc62&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5058fc62"]])

export default __exports__